<?xml version="1.0" encoding="UTF-8"?>
<svg width="10px" height="10px" viewBox="0 0 10 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>D133106B-A108-4EB9-9A4A-E9866344062B@2x</title>
    <desc>Created with Sketch.</desc>
    <g id="Specs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Buttons-&amp;-Inputs" transform="translate(-545.000000, -4216.000000)" fill="#6C6F80">
            <g id="Inputs" transform="translate(120.000000, 1878.000000)">
                <g id="Form-Elements/x/label/36-42/_default-Copy-5" transform="translate(384.000000, 2334.000000)">
                    <g id="Label">
                        <g id="12/notification/ifno-fill" transform="translate(40.000000, 3.000000)">
                            <path d="M6,1 C3.24,1 1,3.24 1,6 C1,8.76 3.24,11 6,11 C8.76,11 11,8.76 11,6 C11,3.24 8.76,1 6,1 Z M6.5,8.5 L5.5,8.5 L5.5,5.5 L6.5,5.5 L6.5,8.5 Z M6.5,4.5 L5.5,4.5 L5.5,3.5 L6.5,3.5 L6.5,4.5 Z" id="icon"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>